import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { ExaminationActionsService } from '@modules/examination/services/examination-actions.service';
import { ExaminationMobileActionsService } from '@modules/examination/services/examination-mobile-actions.service';
import { ActionButtonsComponent } from '@modules/shared/action-buttons/action-buttons.component';
import { ActionButton } from '@shared/models/menu-actions/action-buttons';
import { MenuActionId } from '@shared/models/menu-actions/menu-action-id.enum';
import { TuiCell, TuiIcon, TuiTitle } from '@taiga-ui/core';
import { TuiSkeleton, TuiTooltip } from '@taiga-ui/kit';
import { ExaminationsService } from '../../services/examinations.service';

@Component({
  selector: 'pxc-examination-mobile-pane',
  imports: [CommonModule, TuiTitle, TuiSkeleton, ActionButtonsComponent, TuiIcon, TuiTooltip, TranslocoDirective],
  providers: [ExaminationActionsService, ExaminationMobileActionsService],
  hostDirectives: [TuiCell],
  host: {
    class: 'box-border! flex-1 m-0! min-h-18! px-4! py-2!',
  },
  templateUrl: './examinations-mobile-pane.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExaminationsMobilePaneComponent {
  private readonly examinationsService = inject(ExaminationsService);
  readonly examinationMobileActions = inject(ExaminationMobileActionsService).getActions();
  private readonly translocoService = inject(TranslocoService);

  readonly actionButtons: ActionButton[] = [
    {
      appearance: 'outline',
      title: this.translocoService.translate('Ajouter un examen'),
      actionIds: [MenuActionId.EXAMINATION_CREATE],
    },
    {
      appearance: 'outline',
      title: this.translocoService.translate('Ouvrir'),
      iconEnd: '@tui.arrow-up-right',
      actionIds: [MenuActionId.EXAMINATION_OPEN],
    },
  ];

  readonly description = this.examinationsService.description;

  readonly examinationsCountState$ = this.examinationsService.examinationsCountState$;

  readonly skeletonLength = 3;
}
